import { ImportMappingItemsViewService } from '@/general/services/overview-service/modules/import-mapping-items/import-mapping-items.service';
import { TranslationService } from '@/general/services/translations/translation.service';

export class SupplierImportMappingItemsViewService extends ImportMappingItemsViewService {
  constructor() {
    super(new TranslationService('supplier', 'importMappingItems'));
  }
}
